// extracted by mini-css-extract-plugin
module.exports = {"root":"App_root_2SJlR","logout-modal":"App_logout-modal_1yc6M","tipIcon":"App_tipIcon_1Nubd"};